import React, { Fragment } from 'react';
import Backdrop from "../Backdrop/Backdrop";
import classess from "./Modal.css";


const modal = (props) => {
    let style = {};
    if (!props.show) {
        style = { top: "-100%", opacity: "0" }
    }
    return (
        <Fragment>
            <Backdrop show={props.show} clicked={props.onCloseModal} />
            <div className={classess.Modal} style={style}>
                {props.children}
            </div>
        </Fragment>
    );
}

export default modal;